// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"CustomersPage_tableContainer__F_DIE"};